import React, { memo } from 'react'

import { Icon, RotatingSpinner, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, node, string } from 'prop-types'

const iconSize = { height: '64px', width: '64px' }

// Presentational shell shared by the loading banner variants (generating,
// shared-run, uploading). Owns the centered card; the spinner and __content block
// are optional so the generation-progress variant can supply its own status UI.
// contentChildren render inside __content (after the description); children
// render inside __container (after __content) so each variant keeps the exact
// existing DOM positions.
function LoadingBanner({
  title = '',
  description = null,
  contentChildren = null,
  children = null,
  wrapperClassName = '',
  withSpinner = true,
}) {
  const hasContent = Boolean(title || description || contentChildren)

  return (
    <div className={classnames('loading-banner', wrapperClassName)}>
      <div className="loading-banner__container">
        {withSpinner && <Icon svgComponent={RotatingSpinner} size={iconSize} notSpaced />}
        {hasContent && (
          <div className="loading-banner__content">
            {title && <span className="loading-banner__title cgt-heading-200">{title}</span>}
            {description && <span className="loading-banner__description cgt-body-base">{description}</span>}
            {contentChildren}
          </div>
        )}
        {children}
      </div>
    </div>
  )
}

LoadingBanner.propTypes = {
  title: string,
  description: string,
  contentChildren: node,
  children: node,
  wrapperClassName: string,
  withSpinner: bool,
}

export default memo(LoadingBanner)
